export default __webpack_public_path__ + "static/media/frog-4.606bccd0.png";